<layout-page-container>
  <layout-header-container title="Artikel-Kategorien"/>
  <layout-form-container (clear)="type_name = ''" (submit)="Add()" [element]="name"
                         [hasSearch]="false"
                         [permission]="PermissionService.Inventory_CompositionType_Add()" clearText="Felder leeren"
                         submitText="Artikel-Kategorie anlegen">
    <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">
      <div class="sm:col-span-6">
        <label class="block text-sm font-medium leading-6 text-gray-900" for="category-type-name">Name</label>
        <input #name [(ngModel)]="type_name"
               autocomplete="category-type-name"
               class="mt-2 block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6"
               id="category-type-name" name="category-type-name"
               type="text">
      </div>
    </div>
  </layout-form-container>

  <layout-page-scrollable>
    <table class="min-w-full divide-y divide-gray-300">
      <thead>
      <tr>
        <th class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-2" scope="col">Name</th>
        <th class="hidden py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 lg:table-cell"
            scope="col">
          Geschäftsvorfall
        </th>
        <th class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0" scope="col">MwSt.</th>
        <th class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell" scope="col">Angelegt
          am
        </th>
        <th class="relative py-3.5 pl-3 pr-4 sm:pr-2" scope="col">
          <span class="sr-only">Edit</span>
        </th>
      </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 bg-white">
      <tr *ngFor="let compositionType of compositionTypes" class="select-none">
        <td
          class="whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-2">
          @if (PermissionService.CheckPermission(PermissionService.Permissions_CompositionComponent())) {
            <a [routerLink]="['/'+Routes.Compositions]" [queryParams]="{other: false, type: compositionType.id}">
              {{ compositionType.name }}
            </a>
          } @else {
            <span>
              {{ compositionType.name }}
            </span>
          }
        </td>
        <td
          class="whitespace-nowrap py-2 pl-4 pr-3 text-sm sm:pl-0 text-gray-600 hidden lg:table-cell">{{ BusinessCaseTypeHelper.GetName(compositionType.businessCaseType) }}
        </td>
        <td
          class="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-900 sm:pl-0">{{ (VATRateHelper.GetValue(compositionType.vatRate) * 100).toFixed(2) }}&nbsp;%
        </td>
        <td
          class="hidden whitespace-nowrap px-3 py-2 text-sm text-gray-500 lg:table-cell">{{ (compositionType.created) | date : "dd.MM.yyyy, HH:mm" }}
          Uhr
        </td>
        <td class="whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-2 inline-flex w-full">
          <a (click)="redirectToSettings(compositionType.id)"
             *ngIf="PermissionService.CheckPermission(PermissionService.Inventory_CompositionType_Get())"
             class="cursor-pointer text-gray-600 hover:text-gray-800 place-self-center pr-2 ml-auto">
            <svg class="bi bi-pen" height="20" viewBox="0 0 16 16" width="20"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z"/>
            </svg>
          </a>
          <a (click)="Delete(compositionType)"
             *ngIf="PermissionService.CheckPermission(PermissionService.Inventory_CompositionType_Delete())"
             class="cursor-pointer text-red-600 hover:text-red-900 place-self-center">
            <svg class="bi bi-trash3" height="20" viewBox="0 0 16 16" width="20"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
            </svg>
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </layout-page-scrollable>
</layout-page-container>
